import { CobranzasAxios, COMPANY } from './config'

export const getPayments = async (clientId, year) => {
  const res = await CobranzasAxios.get(`/payment/${clientId}/${COMPANY}/${year}`)
  return res.data
}

export const putPayment = async (paymentId, data) => {
  const res = await CobranzasAxios.put(`/payment/${paymentId}`, data)
  return res.data
}

export const payPayments = async (body, serieId) => {
  const res = await CobranzasAxios.put(`/payment/pay/${serieId}/${COMPANY}`, body)
  return res.data
}

export const deletePayments = async (paymentId) => {
  const res = await CobranzasAxios.delete(`/payment/${paymentId}`)
  return res.data
}

export const assignDiscounts = async (body) => {
  const res = await CobranzasAxios.put('/payment/discounts', body)
  return res.data
}

export const getLastPayment = async (clientId) => {
  const res = await CobranzasAxios.get(`/payment/last-payment/${clientId}/${COMPANY}`)
  return res.data
}

export const generateManualPayment = async (body, serieId) => {
  const res = await CobranzasAxios.put(`/payment/manual/${serieId}`, body)
  return res.data
}

export const generatePayments = async (data, contractId) => {
  const res = await CobranzasAxios.post(`/payment/generate/${contractId}`, data)
  return res.data
}

export const createContractPayment = async (contractId, data) => {
  const res = await CobranzasAxios.post(`/payment/contract/${contractId}/${COMPANY}`, data)
  return res.data
}
